module.exports = __webpack_public_path__ + "img/doc2.c5f3b617.svg";